import React from 'react';
import { Box, Paper, Toolbar, Typography, TextField, Button } from '@mui/material';
import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { fetchInventoryAudit, AuditRow } from '../api/inventory.ts';

const columns: GridColDef[] = [
  { field: 'tenantName', headerName: 'Tenant', flex: 1 },
  { field: 'itemName', headerName: 'Item', flex: 1 },
  { field: 'locationId', headerName: 'Location', width: 120 },
  { field: 'qty', headerName: 'Qty', width: 100 },
  { field: 'par', headerName: 'Par', width: 100 },
  { field: 'gap', headerName: 'Gap', width: 100 },
  { field: 'lastTxn', headerName: 'Last Txn', width: 180 },
];

export default function InventoryAudit(){
  const [rows, setRows] = React.useState<AuditRow[]>([]);
  const [total, setTotal] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [tenantId, setTenantId] = React.useState<number | ''>('' as any);
  const [locationId, setLocationId] = React.useState<number | ''>('' as any);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(20);

  const load = async () => {
    setLoading(true);
    const resp = await fetchInventoryAudit({ tenantId: tenantId?Number(tenantId):undefined, locationId: locationId?Number(locationId):undefined, page, size: pageSize });
    setRows(resp.content || []);
    setTotal(Number(resp.totalElements || 0));
    setLoading(false);
  };

  React.useEffect(()=> { load(); /* eslint-disable-next-line */ }, [tenantId, locationId, page, pageSize]);

  const handlePaginate = (model: GridPaginationModel) => {
    setPage(model.page); setPageSize(model.pageSize);
  };

  const exportCsv = () => {
    const header = ['Tenant','Item','Location','Qty','Par','Gap','LastTxn'];
    const lines = rows.map(r => [r.tenantName, r.itemName, r.locationId, r.qty, r.par, r.gap, r.lastTxn||''].join(','));
    const blob = new Blob([[header.join(',')].concat(lines).join('\n')], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a'); a.href = url; a.download = 'inventory-audit.csv'; a.click(); URL.revokeObjectURL(url);
  };

  return (
    <Box p={2}>
      <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
        <Toolbar disableGutters sx={{ gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="h6" sx={{ flex: 1 }}>Inventory Audit</Typography>
          <TextField label="Tenant ID" size="small" value={tenantId} onChange={(e)=> setTenantId((e.target.value as any))} sx={{ width: 160 }} />
          <TextField label="Location ID" size="small" value={locationId} onChange={(e)=> setLocationId((e.target.value as any))} sx={{ width: 160 }} />
          <Button variant="outlined" onClick={()=> { setPage(0); load(); }}>Refresh</Button>
          <Button variant="contained" onClick={exportCsv}>Export CSV</Button>
        </Toolbar>
      </Paper>

      <Paper elevation={0}>
        <div style={{ height: 560, width: '100%' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            rowCount={total}
            loading={loading}
            pageSizeOptions={[10,20,50]}
            paginationMode="server"
            paginationModel={{ page, pageSize }}
            onPaginationModelChange={handlePaginate}
            disableRowSelectionOnClick
            getRowId={(r)=> r.id}
          />
        </div>
      </Paper>
    </Box>
  );
}


